import {Divider, Stack} from '@mantine/core'
import type {ReactNode} from 'react'

type LocationListProps = {
    items: ReactNode[]
    emptyState?: ReactNode
    footer?: ReactNode
}

export function LocationList({items, emptyState, footer}: LocationListProps) {
    return (
        <Stack gap="md">
            {items.length === 0
                ? emptyState
                : items.map((item, index) => (
                      <Stack key={index} gap="md">
                          {index > 0 ? <Divider /> : null}
                          {item}
                      </Stack>
                  ))}
            {footer}
        </Stack>
    )
}
